// import BalanceGeneral from '@/views/reportes/BalanceGeneral.vue'
// import EstadoResultados from '@/views/reportes/EstadoResultados.vue'
import TratamientoReporte from '@/views/reportes/TratamientoReporte.vue'
import PagosPorTipo from '@/views/reportes/PagosPorTipo.vue'
import DetalleFormaPago from '@/views/reportes/DetalleFormaPago.vue'
import DetalleAseguradora from '@/views/reportes/DetalleAseguradora.vue'
import DetalleSinAseguradora from '@/views/reportes/DetalleSinAseguradora.vue'

// Reportes pendientes
import CitaPendientes from '@/views/reportes/CitaPendientes.vue'
import SuscPagoPendientes from '@/views/reportes/SuscPagoPendientes.vue'
import AtencionResumen from '@/views/reportes/AtencionResumen.vue'

	
export default [
/*   {
    path: '/balance-general',
    name: 'BalanceGeneral',
    component: BalanceGeneral
  },
  {
    path: '/estado-resultados',
    name: 'EstadoResultados',
    component: EstadoResultados
  }, */
  {
    path: '/tratamiento-reporte/:p_idatencion',
    name: 'TratamientoReporte',
    component: TratamientoReporte
  },
  {
    path: '/pagos-por-tipo',
    name: 'PagosPorTipo',
    component: PagosPorTipo
  },
  {
    path: '/detalle-forma-pago/:p_idformapago/:p_formapago/:p_fechadesde/:p_fechahasta',
    name: 'DetalleFormaPago',
    component: DetalleFormaPago
  },
  {
    path: '/detalle-aseguradora/:p_idasegurador/:p_asegurador/:p_fechadesde/:p_fechahasta',
    name: 'DetalleAseguradora',
    component: DetalleAseguradora
  },
  {
    path: '/detalle-sin-aseguradora/:p_fechadesde/:p_fechahasta',
    name: 'DetalleSinAseguradora',
    component: DetalleSinAseguradora
  },
// Reportes pendientes
  {
    path: '/citapendientes',
    name: 'CitaPendientes',
    component: CitaPendientes
  },
  {
    path: '/suscpagopendientes',
    name: 'SuscPagoPendientes',
    component: SuscPagoPendientes
  },
  {
    path: '/AtencionResumen/:p_idatencion',
    name: 'AtencionResumen',
    component: AtencionResumen
  },
//
];